import { DrawCustomMode } from "@mapbox/mapbox-gl-draw";
import { SnapLineMode } from "mapbox-gl-draw-snap-mode";

const drawLineString: DrawCustomMode = {
  ...SnapLineMode,
  // Currently no overrides required
};

export default drawLineString;
